import { debounce } from "lodash";
import { reactive, ref } from "vue";

export const isDragging = ref(false);

export const sliderPosition = reactive({
    x: 0,
    y: 0,
    tableWidth: null,
    gantt: null,
});

export const handleMouseUp = () => {
    isDragging.value = false;
}

export const updateSliderPosition = (x, y) => {
    if (x) sliderPosition.x = x;
    if (y) sliderPosition.y = y;
};

export const pxToVw = (px) => {
    const viewportWidth = window.innerWidth;
    const vw = px / viewportWidth * 100;
    return vw;
}

export const vwToPx = (vw) => {
    const viewportWidth = window.innerWidth;
    const px = viewportWidth * (vw / 100);
    return px;
}

const options = {
    paddingLeft: 20,

}

export const handleMouseMove = debounce((event) => {
    if (isDragging.value) {
        sliderPosition.tableWidth = pxToVw(event.clientX - vwToPx(2));
        sliderPosition.gantt = 100 - pxToVw(event.clientX + vwToPx(2));
    }
}, 1);

